import { IEndereco } from "../../core/interfaces/IEndereco";

export interface IConfiguracaoNFCe {
    uuid?: string;
    razaoSocial: string;
    nomeFantasia: string;
    endereco: IEndereco;
    cnpj: string;
    discriminaImpostos?: boolean;
    email?: string;
    enviarEmailDestinatario?: boolean;
    inscricaoEstadual: number;
    inscricaoMunicipal?: number;
    regimeTributario: RegimeTributarioNfce;
    telefone?: string;
    certificado: ICertificadoDigital;
    csc: string;
    idCsc: string;
    ativo?: boolean;
    criadoAs?: Date;
    excluidoAs?: Date;
    serie?: string;
    proximoNumero?: number;
    modalidadeFrete?: ModalidadeFreteNfce;

    /** Série e numeração da NF-e (modelo 55) são independentes das da NFC-e. */
    emitirNfe?: boolean;
    serieNfe?: string;
    proximoNumeroNfe?: number;
    naturezaOperacaoNfe?: string;
}

export interface ICertificadoDigital {
    senha?: string;
    conteudo?: string;
}

export enum ModalidadeFreteNfce {
    "EMITENTE" = "0", 
    "DESTINATÁRIO" = "1",
    "TERCEIROS" = "2",
    "SEM_FRETE" = "9"
}

export enum RegimeTributarioNfce {
    "Simples Nacional" = 1,
    "Simples Nacional - Excesso de sublimite de receita bruta" = 2,
    "Regime Normal" = 3
}